<template>
  <div style="color: #000" ref="pronbit">
    <div style="height: 100px"></div>
    <div class="service-bg animate__animated animate__backInLeft">
      <img :src="bgImg" alt />
      <div class="common">
        <div class="service-title">
          <div class="service-title-top">{{ title }}</div>
          <div class="service-title-bottom">{{ sTitle }}</div>
        </div>
      </div>
    </div>
    <div
      class="common animate__animated animate__backInLeft"
      style="padding-top: 40px"
    >
      <div class="honor-menu">
        <ul class="honor-menu-ul">
          <li
            v-if="item.show"
            :class="isActive == item.num ? 'active' : ''"
            @click="handleCurrent(item)"
            v-for="(item, index) in ulInfo"
          >
            {{ item.show ? item.name : "" }}
          </li>
        </ul>
      </div>
    </div>

    <!-- 企业简介 -->
    <div
      class="introduction animate__animated animate__backInLeft"
      v-if="isActive == 0"
      key="introduction1"
      style="height: 850px"
    >
      <div class="common">
        <div class="introduction-title">
          <h1 class="introduction-title-h1">
            <b>科技</b>为盾 <b>安全</b>为本 <b>亚太</b>成就您的梦想
          </h1>
          <p>
            Technology as the shield, security as the foundation, Asia Pacific
            to achieve your dream
          </p>
        </div>
        <div class="introduction-cont">
          <div class="introduction-cont-left">
            <img src="../assets/img/introduce-img.jpg" alt />
          </div>
          <div class="introduction-cont-right">
            <p>
              重庆中讯亚太信息技术有限公司成立于2001年，总部位于重庆市南岸区中讯•时代大厦，注册资本3000万。是重庆中讯控股(集团)有限公司旗下的专业从事计算机信息系统集成服务、信息安全服务、运维服务及综合软件研发的高科技企业。公司以“科技开发”与“成熟成果短期产业化”并行的发展模式，在教育、政府、医疗、企业等行业领域形成了较强的技术实力和市场竞争优势，取得了良好的经营业绩。公司拥有国家保密局颁发的涉及国家秘密的计算机信息系统集成乙级资质、电子与智能化工程专业承包贰级资质、ITSS信息技术服务运行维护资质、信息安全服务资质，多次荣获“重庆市优秀系统集成企业”、“守合同重信用单位”、“优秀纳税人”等荣誉称号，并被认定为重庆市“高新技术企业”及“软件企业”。
              <br />
            </p>
            <p>
            经过近二十年的发展，先后控股了东方中讯、中讯亚太科技、北京比尼、四川中讯亚迪四家子公司，成为年营业收入过亿的高科技公司。
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 新闻公告 -->
    <div
      class="news animate__animated animate__backInLeft"
      v-if="isActive == 1"
      key="introduction2"
    >
      <div class="common">
        <ul class="news-ul">
          <li
            class="news-ul-li"
            @click="handleTo('/about', 4, item.id)"
            v-for="(item, index) in leftNewsList"
          >
            <img :src="item.reserved" alt />
            <div class="news-ul-li-bottom">
              <div class="news-ul-li-bottom-left">
                <div class="news-ul-li-bottom-left-year">
                  {{ item.gmtCreate.split("-")[0] }}
                </div>
                <div class="news-ul-li-bottom-left-mon">
                  {{ item.gmtCreate.split("-")[1] }}-
                  {{ item.gmtCreate.split("-")[2].split(" ")[0] }}
                </div>
                <div class="set-line"></div>
              </div>
              <div class="news-ul-li-bottom-right">
                <div class="news-ul-li-bottom-right-title">
                  {{ item.title }}
                </div>
                <div class="news-ul-li-bottom-right-p">
                  {{ item.reservedExtend }}
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="page">
          <ul class="page-ul">
            <li
              :class="page == index ? 'active' : ''"
              v-for="(item, index) in total"
              @click="handleChangePage(index)"
            >
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 新闻详情 -->
    <div
      class="news-cur animate__animated animate__backInLeft"
      v-if="isActive == 4"
      key="introduction2"
    >
      <div class="common">
        <div class="news-top">
          <div class="news-currnet-info">{{ currentNews.title }}</div>
          <div class="news-currnet-info-data">
            {{ currentNews.gmtCreate.split(" ")[0] }}
          </div>
          <div class="new-line"></div>
        </div>
        <div class="new-bottom">
          <div class="new-bottom-left">
            <div v-html="currentNews.content"></div>
          </div>
          <div class="new-bottom-right">
            <div class="new-bottom-right-top">推荐文章</div>
            <ul>
              <li
                v-for="(item, index) in commentNew"
                @click="handleTo('/about', 4, item.id)"
              >
                {{ item.title }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 企业文化 -->
    <div
      class="culture animate__animated animate__backInLeft"
      v-if="isActive == 2"
      key="introduction3"
    >
      <div class="common culture-box">
        <ul>
          <li>
            <img src="../assets/img/culture1.jpg" style="width: 1520px" alt />
          </li>
          <li>
            <img src="../assets/img/culture2.jpg" alt />
          </li>
          <li>
            <img src="../assets/img/culture3.jpg" style="width: 1520px" alt />
          </li>
          <li>
            <img src="../assets/img/core-values.jpg" style="width: 1520px" alt />
          </li>
          <li>
            <img src="../assets/img/development-concept.jpg" style="width: 1520px" alt />
          </li>
          <li>
            <img src="../assets/img/enterprise-tenet.jpg" style="width: 1520px" alt />
          </li>
        </ul>
      </div>
    </div>

    <!-- 企业资质 -->
    <div
      class="honor animate__animated animate__backInLeft"
      v-if="isActive == 3"
      key="introduction4"
    >
      <div class="product-cont">
        <div class="common clearfix">
          <div class="product-cont-left">
            <ul>
              <li @click="handleShowHonor(1)">
                <span :class="isHonorActive == 1 ? 'active' : ''"
                  >企业资质</span
                >
              </li>
              <li @click="handleShowHonor(2)">
                <span :class="isHonorActive == 2 ? 'active' : ''"
                  >企业荣誉</span
                >
              </li>
            </ul>
          </div>
          <div class="product-cont-right2">
            <ul class="honor-cont-right-ul">
              <li v-for="(item, index) in honorList" :key="index">
                <div class="honor-cont-right-ul-div">
                  <img :src="item.img" alt />
                  <div class="honor-cont-right-ul-cont">
                    {{ item.title }}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="page" style="margin-bottom: 30px">
          <ul class="page-ul">
            <li
              :class="honorPage == index ? 'active' : ''"
              v-for="(item, index) in honorTotal"
              @click="handleChangehonorPage(index)"
            >
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import img1 from "../assets/img/about-bg.png";
import img2 from "../assets/img/news-bg.jpg";
import img3 from "../assets/img/culture-bg.jpg";
import img4 from "../assets/img/about-bg.jpg";
import { getNewsInfo, getHonorInfo } from "../api";
export default {
  data() {
    return {
      isHonorActive: 1,
      isActive: 0,
      page: 0,
      total: 1, //多少页
      honorList: [], //荣誉列表
      honorTotal: 0, //荣誉页面多少页
      honorPage: 0,
      leftNewsList: [], //左侧新闻列表
      title: "企业简介", //默认title
      sTitle: "Introduction",
      currentNews: { gmtCreate: "", title: "", content: "" },
      commentNew: [{ title: "" }], //推荐新闻列表
      bgImg: img1,
      ulInfo: [
        {
          name: "企业简介",
          eg: "Introduction",
          num: 0,
          bgImg: img1,
          show: true,
        },
        {
          name: "新闻公告",
          num: 1,
          eg: "News",
          bgImg: img2,
          show: true,
        },
        {
          name: "企业文化",
          num: 2,
          eg: "Culture",
          bgImg: img3,
          show: true,
        },
        {
          name: "资质荣誉",
          num: 3,
          eg: "Honor",
          bgImg: img4,
          show: true,
        },
        {
          name: "新闻公告",
          num: 4,
          eg: "News",
          bgImg: img2,
          show: false,
        },
      ],
    };
  },
  methods: {
    handleCurrent(info) {
      this.isActive = info.num;
      this.title = info.name;
      this.sTitle = info.eg;
      this.bgImg = info.bgImg;
    },
    handleChange(num) {
      // console.log(num);
    },
    async handleShowHonor(type) {
      this.isHonorActive = type;
      let res = await getHonorInfo({
        type,
        curPage: 1,
        limit: 6,
        isPage: 1,
      });
      this.honorList = res.data.data;
      this.honorTotal = res.data.pageTotal;
    },
    async handleChangePage(page) {
      this.page = page;
      let res = await getNewsInfo({ isPage: 1, curPage: page + 1, limit: 4 }); //新闻内容
      this.leftNewsList = res.data.data;
      this.handleToTop();
    },
    async handleChangehonorPage(page) {
      this.honorPage = page;
      let res = await getHonorInfo({
        type: this.isHonorActive,
        curPage: page + 1,
        limit: 6,
        isPage: 1,
      });
      this.honorList = res.data.data;
      this.handleToTop();
    },
    handleToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    handleTo(path, activeNo = 0, id = 0) {
      this.$router.push({
        path,
        query: {
          activeNo,
          id,
        },
      });
    },
  },
  watch: {
    $route: async function (to, from) {
      this.isActive = to.query.activeNo;
      let info = this.ulInfo[this.isActive];
      this.title = info.name;
      this.sTitle = info.eg;
      this.bgImg = info.bgImg;
      let id = this.$route.query.id;
      let res = await getNewsInfo({ id }); //新闻内容
      this.currentNews = res.data.data[0];
      this.handleToTop();
    },
  },
  async mounted() {
    this.isActive = this.$route.query.activeNo;
    let id = this.$route.query.id;
    let res = await getNewsInfo({ id }); //新闻内容
    this.currentNews = res.data.data[0];
    let res2 = await getNewsInfo({ curPage: 1, limit: 4, isPage: 1 }); //所有新闻
    this.commentNew = res2.data.data;
    this.total = res2.data.pageTotal;
    this.leftNewsList = res2.data.data;
    console.log(this.$route.query.isActive);
    this.isHonorActive = this.$route.query.isActive;
    let res3 = await getHonorInfo({
      type: this.$route.query.isActive,
      curPage: 1,
      limit: 6,
      isPage: 1,
    });
    this.honorList = res3.data.data;
    this.honorTotal = res3.data.pageTotal;
    let info = this.ulInfo[this.isActive];
    this.title = info.name;
    this.sTitle = info.eg;
    this.bgImg = info.bgImg;
    this.handleToTop();
  },
  created() {},
};
</script>

<style>
.service-bg {
  height: 450px;
  width: 100%;
  position: relative;
}
.service-bg img {
  width: 100%;
  height: 100%;
}
.service-title {
  height: 190px;
  width: 1500px;
  background-color: #fff;
  position: absolute;
  bottom: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  text-align: left;
  justify-content: center;
  padding-left: 60px;
}
.service-title-top {
  font-size: 38px;
  line-height: 58px;
  font-weight: 800;
}
.service-title-bottom {
  color: #707070;
  font-size: 28px;
}
.honor-menu {
  /* position: absolute; */
  bottom: 198px;
  width: 100%;
  height: 70px;
}
.honor-menu-ul {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}

/* .honor-menu-ul li {
  width: 200px;
  height: 70px;
  color: #2b2b2b;
  font-size: 30px;
  line-height: 70px;
  background-color: #fff;
  border-radius: 20px;
} */
.honor-menu-ul li {
  width: 25%;
  height: 70px;
  font-size: 30px;
}
/* .honor-menu-ul li.active {
  background-color: #4774b6;
  color: #fff;
} */
.honor-menu-ul li.active {
  color: #5694f5;
  font-weight: 600;
  border-bottom: 6px solid #5694f5;
}
.honor-menu-ul li:hover {
  cursor: pointer;
}
.introduction {
  height: 1020px;
  color: #000;
  background-color: #f7f8ff;
}
.introduction-title {
  height: 140px;
  padding-top: 60px;
}
.introduction-title-h1 {
  font-size: 28px;
}
.introduction-title-h1 b {
  font-size: 40px;
  font-weight: 800;
}
.introduction-title p {
  font-size: 14px;
  color: #aaaaaa;
}
.introduction-cont {
  display: flex;
  justify-content: space-between;
  margin-top: 100px;
}
.introduction-cont img {
  width: 990px;
  height: 480px;
}
.introduction-cont p {
  width: 480px;
  min-height: 400px;
  color: #7a7a7a;
  font-size: 18px;
  text-align: left;
  text-indent: 2.8rem;
  line-height: 32px;
}
.news {
  height: 1300px;
  background-color: #f7f8ff;
  padding-top: 160px;
}
.news-cur {
  min-height: 1000px;
  background-color: #f7f8ff;
  padding-top: 100px;
  padding-bottom: 60px;
}
.news-ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.news-ul-li {
  width: 720px;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 2px 2px 10px #dedede;
  margin-bottom: 60px;
}
.news-ul-li img {
  width: 100%;
  /* height: 230px; */
  border-radius: 20px;
}
.news-ul-li-bottom {
  height: 176px;
  display: flex;
  text-align: left;
  justify-content: space-around;
  margin-top: 20px;
}
.news-ul-li-bottom-left {
  position: relative;
  margin-left: 30px;
}
.news-ul-li-bottom-left-year {
  font-size: 30px;
  line-height: 84px;
}
.news-ul-li-bottom-left-mon {
  font-size: 16px;
  color: #888888;
}
.news-ul-li-bottom-right {
  width: 460px;
  margin-left: 20px;
  margin-top: 20px;
  margin-right: 20px;
}
.set-line {
  width: 2px;
  height: 78px;
  background-color: #b4b4b4;
  position: absolute;
  top: 30px;
  left: 140px;
}
.news-ul-li-bottom-right-title {
  font-size: 22px;
  line-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.news-ul-li-bottom-right-p {
  font-size: 18px;
  line-height: 40px;
  color: #979797;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 10px;
}
.my-page {
  font-size: 30px;
  height: 58px;
}
.page-ul {
  width: 800px;
  margin: auto;
  margin-top: 40px;
  text-align: center;
  display: flex;
  justify-content: center;
}
.page-ul li {
  width: 58px;
  height: 58px;
  text-align: center;
  font-size: 28px;
  color: #818181;
  line-height: 58px;
  margin-right: 10px;
  cursor: pointer;
}
.page-ul li.active {
  background-color: #4774b6;
  color: #fff;
}
.culture {
  height: 3000px;
  padding-top: 100px;
  background-color: #f7f8ff;
}
.culture-box{
  width: 100%;
  height: 2880px;
  overflow:hidden;
}
.culture-box ul li {
  width: 100%;
  height: 480px;
  position: relative;
}
.culture-box ul li img {
  width: 100%;
  height: 480px;
}
.culture-box-bg {
  width: 830px;
  height: 480px;
  position: absolute;
  background: url(../assets/img/font-bg.png);
  z-index: 10;
  right: 0;
  top: 0;
}
.culture-box-bg-title {
  margin-top: 20px;
  font-size: 50px;
  line-height: 180px;
  color: #fff;
  font-weight: 800;
}
.culture-box-bg-title span {
  border-bottom: 4px solid #fff;
}
.culture-box-bg-cont {
  font-size: 30px;
  line-height: 60px;
  color: #fff;
  width: 500px;
  margin-left: 280px;
  text-align: left;
}
.culture-box-bg-main {
  margin-left: 40px;
}
.honor {
  min-height: 1100px;
  margin-top: 100px;
}
.product-cont-left {
  float: left;
}
.product-cont-right2 {
  float: right;
  width: 75%;
}
.product-cont-left li {
  font-size: 26px;
  text-align: left;
  width: 240px;
  padding: 20px;
  padding-left: 0;
  border-bottom: 2px solid #c2c2c2;
}
.product-cont-left li:hover {
  cursor: pointer;
}
.product-cont-left li span {
  padding-left: 20px;
}
.product-cont-left li span.active {
  font-weight: 800;
  border-left: 7px solid #4774b6;
}
.honor-cont-right-ul-cont {
  width: 230px;
  font-size: 15px;
  line-height: 28px;
}
.honor-cont-right-ul {
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-around; */
}
.honor-cont-right-ul li {
  width: 330px;
  /* height: 360px; */
  margin-right: 40px;
  margin-bottom: 60px;
  padding-bottom: 10px;
  /* display: flex; */
  flex-direction: column;
  justify-content: center;
}

.honor-cont-right-ul-div {
  background-color: #fff;
  box-shadow: 2px 2px 10px #dedede;
  padding: 20px 0px;
}
.honor-cont-right-ul li img {
  /* width: 320px;
  height: 248px; */
  width: 100%;
  margin: auto;
}
.honor-cont-right-ul-cont {
  margin: auto;
  margin-top: 40px;
  width: 80%;
  text-align: center;
}
.news-top {
  text-align: left;
  font-size: 50px;
  line-height: 80px;
}
.news-currnet-info-data {
  color: #9e9e9e;
  font-size: 30px;
  line-height: 60px;
}
.new-line {
  width: 137px;
  height: 10px;
  background-color: #0a85f8;
  margin-top: 20px;
  margin-bottom: 40px;
  border-radius: 2px;
}
.new-bottom {
  width: 100%;
  margin: auto;
  font-size: 18px;
  line-height: 50px;
  text-align: left;
  text-indent: 3rem;
  display: flex;
  justify-content: space-between;
}
.new-bottom img {
  width: 100%;
  height: 730px;
  margin-bottom: 40px;
}
.new-bottom-left {
  background-color: #fff;
  padding: 100px 80px;
  width: 74%;
  box-shadow: 2px 2px 10px #dedede;
}
.new-bottom-right {
  width: 22%;
  height: 500px;
  background-color: #fff;
  box-shadow: 2px 2px 10px #dedede;
}
.new-bottom-right-top {
  font-size: 36px;
  font-weight: 800;
  color: #232323;
  margin-bottom: 40px;
  margin-top: 40px;
}
.new-bottom-right {
  font-size: 24px;
  line-height: 70px;
}

@media screen and (max-width: 1500px) {
  .honor-menu {
    width: 1000px;
  }
  .service-title {
    height: 190px;
    width: 80%;
  }
  .service-menu-box {
    width: 900px;
  }
  .service-menu-item {
    width: 240px;
    font-size: 22px;
  }
  .service-menu {
    height: 100px;
    padding-top: 10px;
  }
  .honor-menu {
    left: 15%;
    bottom: 198px;
    width: 800px;
    height: 80px;
  }
  .introduction-cont img {
    width: 480px;
    height: 280px;
  }
  .introduction-cont p {
    width: 540px;
    color: #7a7a7a;
    font-size: 16px;
    text-align: left;
    text-indent: 2.8rem;
    font-family: Georgia, serif;
    line-height: 38px;
    margin-left: 20px;
  }
  .introduction {
    height: 700px;
    color: #000;
    background-color: #f7f8ff;
  }
  .news-cur {
    min-height: 1000px;
    background-color: #f7f8ff;
    padding-top: 100px;
    padding-bottom: 60px;
  }
  .news-ul-li {
    width: 48%;
    height: 400px;
  }
  .news-ul-li-bottom-left-year {
    font-size: 22px;
    line-height: 84px;
  }
  .news-ul-li-bottom-left-mon {
    font-size: 16px;
  }
  .news-ul-li-bottom-right {
    width: 300px;
    margin-left: 20px;
    margin-top: 20px;
    margin-right: 20px;
  }
  .set-line {
    top: 30px;
    left: 90px;
  }
  .new-bottom-right li {
    font-size: 16px;
  }
  .new-bottom-right-top {
    line-height: 50px;
  }
  .new-bottom-right-top {
    font-size: 32px;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  .new-bottom img {
    width: 100%;
    height: 430px;
    margin-bottom: 40px;
  }
  .news-currnet-info {
    font-size: 36px;
  }
  .news-currnet-info-data {
    color: #9e9e9e;
    font-size: 26px;
    line-height: 50px;
  }
  .honor-menu-ul li {
    width: 180px;
    height: 70px;
    color: #2b2b2b;
    font-size: 30px;
    line-height: 70px;
    background-color: #fff;
    border-radius: 20px;
  }
  .culture-box-bg-title {
    margin-top: 20px;
    font-size: 40px;
    line-height: 150px;
    color: #fff;
    margin-top: 20px;
    font-weight: 800;
  }
  .product-cont-right {
    float: right;
    width: 70%;
  }
  .honor-menu {
    left: 22%;
  }
}
</style>